import {AbstractModel} from "./abstract-model";

export class Document extends AbstractModel {
  id: number | null = null;
  createdAt: Date | null = null;
  type: string | null = null;
  filename: string | null = null;
  url: string | null = null;
  expireAt: Date | null = null;

  getExpireAtDate(): string | null {
    if (!this.expireAt) {
      return null;
    }

    return this.expireAt.getUTCFullYear() + '-' +
      String(this.expireAt.getUTCMonth() + 1).padStart(2, '0') + '-' +
      String(this.expireAt.getUTCDate()).padStart(2, '0');
  }

  isPdf(): boolean {
    return this.type === 'application/pdf';
  }

  isImage(): boolean {
    return this.type?.startsWith('image/') ?? false;
  }
}
